'use server';
import { actionErrorLog } from '@/shared/infrastructure/logging/actionError';

import type { ActionResult } from '@/shared/types/actions';
import { SessionService } from '@/contexts/authentication';
import { getAudioStoryService } from '@/contexts/audio-stories/services/AudioStoryService';
import { EDIT_FORBIDDEN, guardAudioEdit } from '@/contexts/pipeline-v2/edits/guardAction.server';

export async function uploadBlockRecording(
  audioStoryId: string,
  blockId: string,
  audioBase64: string,
): Promise<ActionResult<{ audioUrl: string }>> {
  const familyId = await SessionService.getFamilyId();
  if (!familyId) return { success: false, error: 'Not authenticated' };
  try {
    const blocked = await guardAudioEdit({ audioStoryId, kind: 'recording' });
    if (blocked) return { success: false, error: blocked.message, code: EDIT_FORBIDDEN };
    const result = await getAudioStoryService().uploadBlockRecording(audioStoryId, blockId, audioBase64, familyId);
    return { success: true, data: result };
  } catch (e: unknown) {
    actionErrorLog('recording', e);
    return { success: false, error: e instanceof Error ? e.message : 'Unknown error' };
  }
}
